
type ValidationType = 'price' | 'nutritional';

export const validateNumericInput = (value: string, type: ValidationType): string | null => {
  // Allow empty values
  if (value === '') return null;
  
  // Check if the value contains any non-numeric characters (except decimal point)
  if (!/^\d*\.?\d*$/.test(value)) {
    return 'Please enter numbers only';
  }
  
  const num = parseFloat(value);
  
  // Check if it's a valid number
  if (isNaN(num)) return 'Please enter a valid number';
  
  switch (type) {
    case 'price':
      if (num <= 0) return 'Price must be greater than 0';
      if (num >= 1000) return 'Price seems unusually high';
      break;
    case 'nutritional':
      if (num < 0) return 'Value cannot be negative';
      if (num > 1000) return 'Value seems unusually high';
      break;
  }
  
  return null;
};
